// extracted by mini-css-extract-plugin
export default {"tableContainer":"CapsulesTable_tableContainer__3tipw","emptyStateCell":"CapsulesTable_emptyStateCell__3zgWn"};